export type EapCypherType = 'TKIP' | 'AES' | 'BOTH';
export type EapType = 'PEAP' | 'TLS' | 'TTLS';

export type EapSettings = {
    id: string;
    name: string;
    ssid: string;
    cipherType: EapCypherType;
    eapType: EapType;
    username: string;
    anonymousUser: string;
    caCertificateFilename?: string;
    clientCertificateFilename: string;
    clientPrivateKeyFilename: string;
    password: string;
    assignedDeviceCount: number;
};

export const EAP_TYPE_OPTIONS: { value: EapType; label: string }[] = [
    { value: 'PEAP', label: 'PEAP' },
    { value: 'TLS', label: 'TLS' },
    { value: 'TTLS', label: 'TTLS' },
];
